import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-text-with-image',
  templateUrl: './circle-text-with-image.component.html',
  styleUrls: ['./circle-text-with-image.component.css']
})
export class CircleTextWithImageComponent {
  @Input() data!:any;
}